import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import AppRoutes from "../config/AppRoutes";
import ApiConfig from "../config/ApiConfig";
import { getUserId } from "../util/storage/accessTokenStorage";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { bool, object } from "yup";
import PURCHASEIRQSelfEmployedView from "../views/IrqSelfEmployedView";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqSelfEmployedPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            isSelfEmployed: bool().required(),
          })}
        >
          <PURCHASEIRQSelfEmployedView
            content={contentMap.RefinanceIrqSelfEmployedPage}
            navigationsAway={customNavigationMap.RefinanceIrqSelfEmployedPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqSelfEmployedPage);
